import { CountryCode as LibphonenumberCountryCode } from "libphonenumber-js"

type MobileCallingCodeData = {
  country: string
  mask: string
  flag: string
  countryCode: LibphonenumberCountryCode
  callingCode: string
}

export const MOBILE_CALLING_CODES = {
  US: {
    country: "United States",
    mask: "000-123-4567",
    flag: "US",
    countryCode: "US",
    callingCode: "1",
  },
  CA: {
    country: "Canada",
    mask: "000-123-4567",
    flag: "CA",
    countryCode: "CA",
    callingCode: "1",
  },
  GB: {
    country: "United Kingdom",
    mask: "7123 456789",
    flag: "GB",
    countryCode: "GB",
    callingCode: "44",
  },
  DE: {
    country: "Germany",
    mask: "0123 4567890",
    flag: "DE",
    countryCode: "DE",
    callingCode: "49",
  },
  ES: {
    country: "Spain",
    mask: "012 345 678",
    flag: "ES",
    countryCode: "ES",
    callingCode: "34",
  },
  FR: {
    country: "France",
    mask: "01 23 45 67 89",
    flag: "FR",
    countryCode: "FR",
    callingCode: "33",
  },
  IT: {
    country: "Italy",
    mask: "012 345 6789",
    flag: "IT",
    countryCode: "IT",
    callingCode: "39",
  },

  MX: {
    country: "Mexico",
    mask: "000 000 0000",
    flag: "MX",
    countryCode: "MX",
    callingCode: "52",
  },
  NL: {
    country: "Netherlands",
    mask: "06 00000000",
    flag: "NL",
    countryCode: "NL",
    callingCode: "31",
  },
  GR: {
    country: "Greece",
    mask: "69 0000 0000",
    flag: "GR",
    countryCode: "GR",
    callingCode: "30",
  },
  AU: {
    country: "Australia",
    mask: "04 0000 0000",
    flag: "AU",
    countryCode: "AU",
    callingCode: "61",
  },
  JP: {
    country: "Japan",
    mask: "0 90 0000 0000",
    flag: "JP",
    countryCode: "JP",
    callingCode: "81",
  },
  BR: {
    country: "Brazil",
    mask: "00 9 0000 0000",
    flag: "BR",
    countryCode: "BR",
    callingCode: "55",
  },
} as const

export type CountryCode = keyof typeof MOBILE_CALLING_CODES
